import React, { useState, useEffect, useRef } from 'react';
import MunicipiosApi from '../../services/robinhood/MunicipiosApi';
import { Link, useNavigate } from 'react-router-dom';


export default function MunicipioAdicionar(props) {

    const [municipios, setMunicipios] = useState([]);
    const [municipio, setMunicipio] = useState({ 'id': null, 'municipio': null });
    const [municipio_id, setMunicipio_id] = useState(null);
    const buttonSelecionar = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        document.getElementById('toggle-menu').className = 'theme-blush ls-toggle-menu';
        new MunicipiosApi().all().then(response => {
            setMunicipios(response);
        });
    }, []);


    const HandlerMunicipioAdicionar = () => {
        if (municipio.id) {
            buttonSelecionar.current.setAttribute('data-dismiss', "modal");
            buttonSelecionar.current.click();
            props.municipioAdicionar(municipio);
        }
    }

    const HandlerMunicipioAdicionarTodos = () => {

        buttonSelecionar.current.setAttribute('data-dismiss', "modal");
        buttonSelecionar.current.click();
        props.municipioAdicionarTodos();

    }

    return (
        <>
            <div class="modal fade" id="largeModalMunicipioAdicionar" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h6 class="modal-title" style={{ textTransform: 'uppercase' }} id="largeModalLabel">{props.titulo}</h6>
                        </div>
                        <div class="modal-body">
                            <p>
                                Selecione o município no qual deseja adicionar na lista de comparações.
                            </p>
                            <p className=''>
                                <div className='form-inline '>
                                    <label className='m-r-10'>Municípios: </label>
                                    <select className='form-control col-12' id='municipio_id' onChange={(event) => setMunicipio({ 'id': event.target.value, 'municipio': event.target.selectedOptions[0].text })} style={{ minWidth: '500px' }}>
                                        <option selected disabled><span>Selecione</span></option>
                                        {municipios.map(municipio => {
                                            return <option key={municipio.id} value={municipio.id}  > {municipio.municipio} </option>
                                        })}
                                    </select>
                                    {/* <Link ref={buttonSelecionar} onClick={() => HandlerMunicipioAdicionar()} class="btn btn-link waves-effect bg-light m-l-5" > <i className='zmdi'></i> ADICIONAR TODOS </Link> */}

                                </div>
                            </p>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn  btn-link btn-light waves-effect m-r-10 small" data-dismiss="modal"> FECHAR </button>
                            <Link onClick={() => HandlerMunicipioAdicionarTodos()} class="btn btn-link waves-effect bg-light small " > <i className='zmdi'></i> ADICIONAR TODOS </Link>
                            <Link ref={buttonSelecionar} onClick={() => HandlerMunicipioAdicionar()} class="btn btn-link waves-effect bg-green text-white " > <i className='zmdi zmdi-plus'></i> ADICIONAR SELECIONADO</Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

